import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface FeaturePointRlt2Props {
  children: React.ReactNode;
}
const FeaturePointRlt2 = ({
  children
}: FeaturePointRlt2Props) => {
  return <div className="flex items-start" data-id="element-6906">
      <CheckCircleIcon className="h-4 w-4 text-gray-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-6907" />
      <span className="text-sm text-gray-700" data-id="element-6908">{children}</span>
    </div>;
};
export default FeaturePointRlt2;